// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Analysis report — PDF export (extends maturity-analysis-pdf.css) */

.ap-pdf-kpis.is-3 {
  grid-template-columns: repeat(3, 1fr);
}

.ap-pdf-kpis.is-1 {
  grid-template-columns: 1fr;
}

.ap-pdf-kpis.is-3 .ma-pdf-kpi-value {
  font-size: 24px;
}

.ap-pdf-kpi-label {
  max-width: none;
}

.ap-pdf-grid {
  margin: 0 60px 18px;
}

.ap-pdf-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.ap-pdf-row.is-single {
  grid-template-columns: 1fr;
}

.ap-pdf-row + .ap-pdf-row {
  margin-top: 12px;
}

.ap-pdf-grid .ma-pdf-card {
  margin: 0;
}

.ap-pdf-chart .ma-pdf-card-head h2 {
  font-size: 13px;
  line-height: 1.35;
}

/* Full labels in the PDF — no one-line ellipsis */
.ap-pdf .ma-pie-layout {
  grid-template-columns: 1fr;
  justify-items: center;
  gap: 10px;
}

.ap-pdf .ma-pie-legend-label,
.ap-pdf .ma-bar-legend-label,
.ap-pdf .ma-pie-center span {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  overflow-wrap: anywhere;
  display: block;
  -webkit-line-clamp: unset;
  max-width: none;
}

.ap-pdf .ma-chart-canvas--bar {
  height: 170px;
}

.ap-pdf .ma-chart-canvas--line {
  height: 220px;
}

.ap-pdf .ma-bar-layout {
  grid-template-columns: 1fr;
  gap: 10px;
}

.ap-pdf-table-card .ma-pdf-card-head,
.ap-pdf-extra .ma-pdf-card-head {
  align-items: center;
}

.ap-pdf-table {
  font-size: 12px;
}

.ap-pdf-trow {
  display: grid;
  gap: 16px;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid #eaf0f0;
  color: #0b1e2d;
  line-height: 1.4;
}

.ap-pdf-trow:nth-child(odd):not(.ap-pdf-thead) {
  background: #fbfcfd;
}

.ap-pdf-trow:last-child {
  border-bottom: none;
}

.ap-pdf-trow span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.ap-pdf-table.is-numeric-last .ap-pdf-trow span:last-child {
  text-align: right;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.ap-pdf-thead {
  padding-top: 9px;
  padding-bottom: 9px;
  background: #f7fafa;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  color: #5f7484;
}

.ap-pdf-table.is-numeric-last .ap-pdf-thead span:last-child {
  font-weight: 800;
}
`, "",{"version":3,"sources":["webpack://./src/Pdf/analysis-pdf.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;EACE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,SAAS;AACX;;AAEA;;;EAGE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Analysis report — PDF export (extends maturity-analysis-pdf.css) */\n\n.ap-pdf-kpis.is-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.ap-pdf-kpis.is-1 {\n  grid-template-columns: 1fr;\n}\n\n.ap-pdf-kpis.is-3 .ma-pdf-kpi-value {\n  font-size: 24px;\n}\n\n.ap-pdf-kpi-label {\n  max-width: none;\n}\n\n.ap-pdf-grid {\n  margin: 0 60px 18px;\n}\n\n.ap-pdf-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.ap-pdf-row.is-single {\n  grid-template-columns: 1fr;\n}\n\n.ap-pdf-row + .ap-pdf-row {\n  margin-top: 12px;\n}\n\n.ap-pdf-grid .ma-pdf-card {\n  margin: 0;\n}\n\n.ap-pdf-chart .ma-pdf-card-head h2 {\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n/* Full labels in the PDF — no one-line ellipsis */\n.ap-pdf .ma-pie-layout {\n  grid-template-columns: 1fr;\n  justify-items: center;\n  gap: 10px;\n}\n\n.ap-pdf .ma-pie-legend-label,\n.ap-pdf .ma-bar-legend-label,\n.ap-pdf .ma-pie-center span {\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n  overflow-wrap: anywhere;\n  display: block;\n  -webkit-line-clamp: unset;\n  max-width: none;\n}\n\n.ap-pdf .ma-chart-canvas--bar {\n  height: 170px;\n}\n\n.ap-pdf .ma-chart-canvas--line {\n  height: 220px;\n}\n\n.ap-pdf .ma-bar-layout {\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.ap-pdf-table-card .ma-pdf-card-head,\n.ap-pdf-extra .ma-pdf-card-head {\n  align-items: center;\n}\n\n.ap-pdf-table {\n  font-size: 12px;\n}\n\n.ap-pdf-trow {\n  display: grid;\n  gap: 16px;\n  align-items: center;\n  padding: 10px 16px;\n  border-bottom: 1px solid #eaf0f0;\n  color: #0b1e2d;\n  line-height: 1.4;\n}\n\n.ap-pdf-trow:nth-child(odd):not(.ap-pdf-thead) {\n  background: #fbfcfd;\n}\n\n.ap-pdf-trow:last-child {\n  border-bottom: none;\n}\n\n.ap-pdf-trow span {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.ap-pdf-table.is-numeric-last .ap-pdf-trow span:last-child {\n  text-align: right;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.ap-pdf-thead {\n  padding-top: 9px;\n  padding-bottom: 9px;\n  background: #f7fafa;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: #5f7484;\n}\n\n.ap-pdf-table.is-numeric-last .ap-pdf-thead span:last-child {\n  font-weight: 800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
